import { render, staticRenderFns } from "./magicLink.vue?vue&type=template&id=0777d9a0&scoped=true"
import script from "./magicLink.vue?vue&type=script&lang=js"
export * from "./magicLink.vue?vue&type=script&lang=js"
import style0 from "./magicLink.vue?vue&type=style&index=0&id=0777d9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0777d9a0",
  null
  
)

export default component.exports